import { BadgeProps } from '@doveit/bricks';
import { OfferDeedStatus } from '../../../domain/types';
import { ComputedOfferDeedStatus } from '../../hooks/use-computed-offer-deed-status/useComputedOfferDeedStatus';

export const computedOfferDeedStatusLabels: Record<ComputedOfferDeedStatus, string> = {
  [OfferDeedStatus.EXACT]: 'Da rogitare',
  [OfferDeedStatus.VAGUE]: 'Da rogitare',
  [OfferDeedStatus.CONFIRMED]: 'Rogitato',
};

export const updateOfferDeedStatusColors: Record<ComputedOfferDeedStatus, BadgeProps['color']> = {
  [OfferDeedStatus.EXACT]: 'warning',
  [OfferDeedStatus.VAGUE]: 'warning',
  [OfferDeedStatus.CONFIRMED]: 'success',
};
